export default "__VITE_ASSET__C59IBj3$__"